import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import ILocalState from './stateInterface';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import { CheckoutMethods } from '@/enums/CheckoutMethods';

const colorList = [
    '#44355b',
    '#664068',
    '#894b70',
    '#a95872',
    '#c66871',
    '#de7d6d',
    '#ee9669',
    '#f7b267',
];

const initState: ILocalState = {
    shoppingCartRecords: null,
    userData: null,
    checkoutList: null,
    projectBillingsSubscription: null,
    projectBillingsCredits: null,
    activeAccount: null,
    billingAddresses: null,
    bluesnapToken: null,
    isUserAuthorized: false,
    invoices: null,
    projectBillings: null,
    activeCheckoutMethod: CheckoutMethods.payPerView,
    loginRecords: null,
    userColor: colorList[Math.floor(Math.random() * colorList.length)],
    currentReportDetails: null,
    currentStatisticalAnalysis: null,
    activeProductGroup: ProductGroupTypes.None,
    token: null,
    shoppingListRecords: null,
    filteredShoppingListRecords: [],
    countryList: null,
    switchedUserEmail: null,
    cartSummary: null,
    trademarksShopListItems: null,
    trademarksShopCartItems: null,
    customerShopListItems: null,
    customerShopCartItems: null,
    goodwillShopListItems: null,
    goodwillShopCartItems: null,
    technologyShopListItems: null,
    technologyShopCartItems: null,
    softwareShopListItems: null,
    softwareShopCartItems: null,
};

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations,
};
